import { Server, Wifi, Network, Radio, Shield, Cpu, Tablet } from 'lucide-react';
import clsx from 'clsx';
import { normalizeTypeSlug } from '../typeSlugs';

/**
 * Individual tab for device type selection
 */
const DeviceTypeTab = ({ type, isActive, onClick, deviceCount = 0 }) => {
  // Get icon component with fallback
  const getIcon = () => {
    const iconMap = {
      'hosts': Server,
      'router': Wifi,
      'switch': Network,
      'access-point': Radio,
      'firewall': Shield,
      'appliance': Cpu,
      'mobile': Tablet
    };

    const IconComponent = iconMap[normalizeTypeSlug(type.slug)] || Cpu;
    return <IconComponent size={16} />;
  };

  // Get color classes with fallback
  const getColorClasses = () => {
    if (isActive) {
      return 'text-theme-primary border-theme-primary bg-theme-primary/10';
    }

    return 'text-gray-500 border-gray-200 bg-white hover:bg-gray-50 hover:text-gray-700';
  };

  const getBadgeClasses = () => {
    if (isActive) {
      return 'bg-theme-primary';
    }

    return 'bg-gray-500';
  };

  return (
    <button
      className={clsx(
        'flex items-center gap-2 px-4 py-2 rounded-lg border-2 transition-all duration-200',
        'font-medium text-sm',
        getColorClasses()
      )}
      onClick={onClick}
    >
      {getIcon()}
      <span>{type.name}</span>
      {deviceCount > 0 && (
        <span
          className={clsx(
            'px-2 py-0.5 text-xs text-white rounded-full',
            getBadgeClasses()
          )}
        >
          {deviceCount}
        </span>
      )}
    </button>
  );
};

export default DeviceTypeTab;